// AI Generated file
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'escapeHtml',
    standalone: false,
})
export class EscapeHtmlPipe implements PipeTransform {
    transform (str: string): string {
        const entityMap: { [key: string]: string } = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            '\'': '&#39;',
            '/': '/',
        };

        str = str || '';
        return String(str).replace(/[&<>"'/]/g, (s) => {
            return entityMap[s];
        });
    }
}
